import { useContext, useEffect, useState } from "react";
import { TranslationService } from "../../services/TranslationService";
import { FloatingPanelFooter } from "../shared/components/FloatingPanelFooter";
import FloatingPanelService from "../shared/FloatingPanel";
import { RoleGetResponse } from "./entities/RoleGetResponse";
import RoleService from "../../services/RoleService";
import ToastContext from "../shared/bootstrap/Toast";
import {
  CheckBoxEditor,
  TextEditor,
  MultiselectEditor
} from "../shared/components/Editors";
import CompanyService from "../../services/CompanyService";
import { RequiredManager, ValidationMessage } from "../shared/RequieredManager";
import TooltipComponent from "../shared/TooltipComponent";
import { getError } from "../../utils/RequestUtils";
import {
  cashappPermissionGroups,
  cashappPermissionKeys
} from "../shared/cashappPermissions";
import Tabs from "../shared/components/Tabs";

const permissions = [
  "NewPerson",
  "EditPerson",
  "DeletePerson",
  "SetFieldsPerson",

  "NewIO",
  "EditIO",
  "DeleteIO",
  "SetFieldsIO",

  "EditIOStatus",
  "DisableIOStatusEdit",

  "NewTransaction",
  "EditTransaction",
  "DeleteTransaction",
  "SetFieldsTransaction",

  "EditTransactionType",

  "NewComment",
  "EditComment",
  "DeleteComment",
  "ImportComment",

  "NewWhatsapp",
  "EditWhatsapp",
  "DeleteWhatsapp",
  "SetTemplateWhatsapp",

  "NewMail",
  "EditMail",
  "DeleteMail",
  "SetTemplateEmail",

  "SetTemplateSMS",
  "SetPayment",

  "NewTask",
  "EditTask",
  "DeleteTask",
  "CheckTask",
  "CheckOthersTask",

  "NewTag",
  "EditTag",
  "DeleteTag",

  "ViewReport",

  "EditSegment",

  "ViewAction",
  "EditAction",

  "SetCompany",
  "SetCompanyOtherSettings",

  "ViewRole",
  "EditRole",

  "ViewUser",
  "EditUser",

  "EditActivityType",

  "ViewImportLog",
  "SetImport",

  "EditDashboard",

  "SetAIAssistant",

  "Export",
  "UseMCP"
];

export class RoleEditModel {
  segments: string[] = [];
  creatorUserId?: number;
  chooseSegments: boolean = false;
  DashboardPanelID?: number;

  NewPerson: boolean = true;
  EditPerson: boolean = true;
  DeletePerson: boolean = true;
  SetFieldsPerson: boolean = true;

  NewIO: boolean = true;
  EditIO: boolean = true;
  DeleteIO: boolean = true;
  SetFieldsIO: boolean = true;

  EditIOStatus: boolean = true;
  DisableIOStatusEdit: boolean = false;

  NewTransaction: boolean = true;
  EditTransaction: boolean = true;
  DeleteTransaction: boolean = true;
  SetFieldsTransaction: boolean = true;

  EditTransactionType: boolean = true;

  NewComment: boolean = true;
  EditComment: boolean = true;
  DeleteComment: boolean = true;
  ImportComment: boolean = true;

  NewWhatsapp: boolean = true;
  EditWhatsapp: boolean = true;
  DeleteWhatsapp: boolean = true;
  SetTemplateWhatsapp: boolean = true;

  NewMail: boolean = true;
  EditMail: boolean = true;
  DeleteMail: boolean = true;
  SetTemplateEmail: boolean = true;

  SetTemplateSMS: boolean = true;
  SetPayment: boolean = true;

  NewTask: boolean = true;
  EditTask: boolean = true;
  DeleteTask: boolean = true;
  CheckTask: boolean = true;
  CheckOthersTask: boolean = true;

  NewTag: boolean = true;
  EditTag: boolean = true;
  DeleteTag: boolean = true;

  ViewReport: boolean = true;

  EditSegment: boolean = true;

  ViewAction: boolean = true;
  EditAction: boolean = true;

  SetCompany: boolean = true;
  SetCompanyOtherSettings: boolean = true;

  ViewRole: boolean = true;
  EditRole: boolean = true;

  ViewUser: boolean = true;
  EditUser: boolean = true;

  EditActivityType: boolean = true;

  ViewImportLog: boolean = true;
  SetImport: boolean = true;

  EditDashboard: boolean = true;

  SetAIAssistant: boolean = true;
  UseMCP: boolean = true;

  Export: boolean = true;

  // Permisos Cashapp (columnas Cashapp* de la tabla role unificada). Opt-in:
  // por defecto apagados (un rol no otorga permisos cashapp salvo que se marquen).
  CashappClientSee: boolean = false;
  CashappClientImport: boolean = false;
  CashappClientExport: boolean = false;
  CashappInvoiceSee: boolean = false;
  CashappInvoiceImport: boolean = false;
  CashappInvoiceAdjunstmentImport: boolean = false;
  CashappInvoiceExport: boolean = false;
  CashappPaymentSee: boolean = false;
  CashappPaymentImport: boolean = false;
  CashappPaymentAssignClient: boolean = false;
  CashappPaymentExport: boolean = false;
  CashappPaymentFileDelete: boolean = false;
  CashappManuallyCreatedPaymentEdit: boolean = false;
  CashappManuallyCreatedPaymentDelete: boolean = false;
  CashappInvoicePaymentSee: boolean = false;
  CashappInvoicePaymentCreateWithClientAndInvoice: boolean = false;
  CashappInvoicePaymentCreateWithClientNoInvoice: boolean = false;
  CashappInvoicePaymentCreateWithNoClient: boolean = false;
  CashappInvoicePaymentEdit: boolean = false;
  CashappInvoicePaymentDelete: boolean = false;
  CashappInvoicePaymentExport: boolean = false;
  CashappInvoicePaymentImport: boolean = false;
  CashappReceiptSee: boolean = false;
  CashappReceiptCreate: boolean = false;
  CashappReceiptApprove: boolean = false;
  CashappRuleSee: boolean = false;
  CashappRuleCreate: boolean = false;
  CashappRuleEdit: boolean = false;
  CashappRuleDelete: boolean = false;
  CashappAccountManage: boolean = false;
  CashappCurrencyManage: boolean = false;
  CashappFieldsManage: boolean = false;
  CashappActionLogListSee: boolean = false;

  CashApp: boolean = false;
  Created: string = "";
  DisableSegmentEmail: boolean = false;
  Name: string;
  ReadOnly: boolean = false;
  RoleID: number = 0;
  User_Company_Role: any[];
  AllowStatusIds?: number[];

  constructor(rol?: RoleGetResponse.Role) {
    if (!rol) {
      return;
    }

    this.Name = rol.Name;
    this.RoleID = rol.RoleID;

    permissions.forEach((permission: string) => {
      (this[permission as keyof RoleEditModel] as boolean) = (rol[
        permission as keyof typeof rol
      ] ?? false) as boolean;
    });

    cashappPermissionKeys.forEach((permission: string) => {
      (this[permission as keyof RoleEditModel] as boolean) = (rol[
        permission as keyof typeof rol
      ] ?? false) as boolean;
    });

    if (rol.AllowStatusIds) {
      this.AllowStatusIds = rol.AllowStatusIds;
    }
  }
}

export const RoleEdit = ({
  roleId,
  onSubmit,
  readonly = false,
  roles
}: any) => {
  const { showToast } = useContext(ToastContext);
  const { translate } = TranslationService;
  const [saving, setSaving] = useState(false);
  const [roleEdit, setRoleEdit] = useState(new RoleEditModel());
  const [activeTab, setActiveTab] = useState<"cobranzas" | "cashapp">(
    "cobranzas"
  );
  const requiredManager = new RequiredManager();

  const isLoadingRole = () => roleId && roleEdit.RoleID === 0;

  useEffect(() => {
    const loadRole = async () => {
      if (!roleId) {
        let newUser = new RoleEditModel();
        setRoleEdit(newUser);
        return;
      }
      const result = await RoleService.get(roleId.toString());
      if (result instanceof Error) {
        showToast(translate.ErrorProcessingRequest, undefined, "danger");
        return undefined;
      }
      const newUserEdit = new RoleEditModel(result?.item);
      setRoleEdit(newUserEdit);
      return;
    };

    loadRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleId]);

  const canSubmit = () =>
    !isLoadingRole() && !saving && requiredManager.validate();

  const submit = async () => {
    if (!canSubmit()) {
      return;
    }

    setSaving(true);

    const result = await RoleService.set(roleEdit);
    if (result instanceof Error) {
      const err = getError(result);
      let errorMessage = translate.ErrorProcessingRequest;
      if (err.status === 400) {
        if (err.message === "Fail-Exists") {
          errorMessage = translate.IdentifierAlreadyInUsed;
        }
      }
      showToast(errorMessage, undefined, "danger");
      setSaving(false);
    } else {
      showToast(translate.SavedChanges, undefined, "success");
      onSubmit && onSubmit();
      FloatingPanelService.hidePanel();
    }
  };

  const chkAllPermissions = (checked: boolean) => {
    permissions.forEach((permission: string) => {
      (roleEdit[permission as keyof RoleEditModel] as boolean) = checked;
    });
    roleEdit.DisableIOStatusEdit = !checked;
    roleEdit.CheckOthersTask = !checked;
    setRoleEdit({ ...roleEdit });
  };

  const chkAllCashappPermissions = (checked: boolean) => {
    cashappPermissionKeys.forEach((permission: string) => {
      (roleEdit[permission as keyof RoleEditModel] as boolean) = checked;
    });
    setRoleEdit({ ...roleEdit });
  };

  const updateRole =
    (propName: string) =>
    (value: string | string[] | number | number[] | boolean | undefined) => {
      setRoleEdit((role) => ({ ...role, [propName]: value }));
    };

  const onRoleNameChange = requiredManager.makeRequired(updateRole("Name"));
  const cancelReturn = () => FloatingPanelService.hidePanel();

  const showCashapp = CompanyService.canShowCashApp();
  const currentTab = showCashapp ? activeTab : "cobranzas";
  // Cuenta el estado MOSTRADO del checkbox (hay 2 permisos invertidos en la UI),
  // para que el budget coincida con "Marcar todo".
  const isCobranzasPermissionChecked = (key: string): boolean => {
    if (key === "DisableIOStatusEdit") {
      return !roleEdit.DisableIOStatusEdit;
    }
    if (key === "CheckTask") {
      return roleEdit.EditTask || roleEdit.CheckTask;
    }
    if (key === "CheckOthersTask") {
      return (
        roleEdit.EditTask || (roleEdit.CheckTask && !roleEdit.CheckOthersTask)
      );
    }
    return roleEdit[key as keyof RoleEditModel] as boolean;
  };
  const cobranzasSelectedCount = permissions.filter(
    isCobranzasPermissionChecked
  ).length;
  const cashappSelectedCount = cashappPermissionKeys.filter(
    (key) => roleEdit[key as keyof RoleEditModel] as boolean
  ).length;

  return (
    <>
      <div className="floatingBody p-4">
        {isLoadingRole() ? (
          <i className="fas fa-spinner-third fa-spin third ms-2"></i>
        ) : (
          <>
            <div className="row">
              <div className="col">
                <div className="d-flex input-column mb-3">
                  <label className="form-label me-4 w-75px">
                    {translate.Rol}
                  </label>
                  {roleEdit.RoleID && readonly ? (
                    <div className="d-flex align-items-center">
                      <span>{roleEdit.Name}</span>
                    </div>
                  ) : (
                    <>
                      <TextEditor
                        onChange={onRoleNameChange}
                        defaultValue={roleEdit.Name}
                      />
                      <ValidationMessage
                        onChange={onRoleNameChange}
                        message={translate.RequiredField}
                        defaultValue={roleEdit.Name}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            {showCashapp && (
              <Tabs
                activeId={currentTab}
                onChange={(id) => setActiveTab(id as "cobranzas" | "cashapp")}
                items={[
                  {
                    id: "cobranzas",
                    label: translate.Cobranzas,
                    badge: `${cobranzasSelectedCount}/${permissions.length}`
                  },
                  {
                    id: "cashapp",
                    label: translate.Cashapp,
                    badge: `${cashappSelectedCount}/${cashappPermissionKeys.length}`
                  }
                ]}
              />
            )}

            {(!showCashapp || currentTab === "cobranzas") && (
              <>
                <div className="row mb-2" style={{ alignItems: "end" }}>
                  <div className="col-auto">
                    <h2 className="pe-4 pb-1">{translate.Permissions}</h2>
                  </div>
                  <div className="col">
                    <CheckBoxEditor
                      disabled={readonly}
                      onChange={chkAllPermissions}
                      message={translate.CheckAll}
                    ></CheckBoxEditor>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Clients}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewPerson")}
                          message={translate.Create}
                          value={roleEdit.NewPerson}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditPerson")}
                          message={translate.Edit}
                          value={roleEdit.EditPerson}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeletePerson")}
                          message={translate.Delete}
                          value={roleEdit.DeletePerson}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetFieldsPerson")}
                          message={translate.SetFields}
                          value={roleEdit.SetFieldsPerson}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Invoices}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewIO")}
                          message={translate.Create}
                          value={roleEdit.NewIO}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditIO")}
                          message={translate.Edit}
                          value={roleEdit.EditIO}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeleteIO")}
                          message={translate.Delete}
                          value={roleEdit.DeleteIO}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetFieldsIO")}
                          message={translate.SetFields}
                          value={roleEdit.SetFieldsIO}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.EstadosFacturas}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditIOStatus")}
                          message={translate.Configure}
                          value={roleEdit.EditIOStatus}
                        ></CheckBoxEditor>
                        <div className="d-flex align-items-center">
                          <CheckBoxEditor
                            addClass="my-0"
                            disabled={readonly}
                            onChange={(checked) =>
                              updateRole("DisableIOStatusEdit")(!checked)
                            }
                            message={translate.ChangeStatus}
                            value={!roleEdit.DisableIOStatusEdit}
                          ></CheckBoxEditor>
                          <TooltipComponent
                            title={`Al marcar esta opción, el usuario podrá cambiar los estados de las facturas. Por ejemplo, podrá cambiar una factura de un estado "Normal" a "Promesa de pago`}
                          >
                            <i className="fal fa-question-circle ms-2" />
                          </TooltipComponent>
                        </div>
                      </div>
                    </div>
                    {!roleEdit.DisableIOStatusEdit && (
                      <div className="d-flex input-column mb-3 ms-3">
                        <label className="form-label me-4">
                          {translate.IOStatus}
                        </label>
                        <div style={{ minWidth: 300 }}>
                          <MultiselectEditor
                            items={CompanyService.getIoStatus().map(
                              (status) => ({
                                value: status.IOStatusID.toString(),
                                label: status.Value
                              })
                            )}
                            defaultValue={roleEdit.AllowStatusIds?.map(
                              (id) => ({
                                value: id.toString(),
                                label:
                                  CompanyService.getIoStatus().find(
                                    (s) => s.IOStatusID === id
                                  )?.Value || id.toString()
                              })
                            )}
                            callback={(values) => {
                              const statusIds = values
                                ? values.map((v) => parseInt(v))
                                : [];
                              updateRole("AllowStatusIds")(statusIds);
                            }}
                            placeholder={translate.Select}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Payments}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewTransaction")}
                          message={translate.Create}
                          value={roleEdit.NewTransaction}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditTransaction")}
                          message={translate.Edit}
                          value={roleEdit.EditTransaction}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeleteTransaction")}
                          message={translate.Delete}
                          value={roleEdit.DeleteTransaction}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetFieldsTransaction")}
                          message={translate.SetFields}
                          value={roleEdit.SetFieldsTransaction}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.PaymentTypes}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditTransactionType")}
                          message={translate.SetFields}
                          value={roleEdit.EditTransactionType}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Comments}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewComment")}
                          message={translate.Create}
                          value={roleEdit.NewComment}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditComment")}
                          message={translate.Edit}
                          value={roleEdit.EditComment}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeleteComment")}
                          message={translate.Delete}
                          value={roleEdit.DeleteComment}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("ImportComment")}
                          message={translate.ImportAction}
                          value={roleEdit.ImportComment}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Whatsapp}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewWhatsapp")}
                          message={translate.Create}
                          value={roleEdit.NewWhatsapp}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditWhatsapp")}
                          message={translate.Edit}
                          value={roleEdit.EditWhatsapp}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeleteWhatsapp")}
                          message={translate.Delete}
                          value={roleEdit.DeleteWhatsapp}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetTemplateWhatsapp")}
                          message={translate.SetTemplate}
                          value={roleEdit.SetTemplateWhatsapp}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Emails}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewMail")}
                          message={translate.Send}
                          value={roleEdit.NewMail}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditMail")}
                          message={translate.Edit}
                          value={roleEdit.EditMail}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeleteMail")}
                          message={translate.Delete}
                          value={roleEdit.DeleteMail}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetTemplateEmail")}
                          message={translate.SetTemplate}
                          value={roleEdit.SetTemplateEmail}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.SMSTemplates}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetTemplateSMS")}
                          message={translate.Configure}
                          value={roleEdit.SetTemplateSMS}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.PaymentGateway}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetPayment")}
                          message={translate.Configure}
                          value={roleEdit.SetPayment}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Tasks}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewTask")}
                          message={translate.Create}
                          value={roleEdit.NewTask}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={(x) => {
                            updateRole("EditTask")(x);
                            updateRole("CheckTask")(false);
                            updateRole("CheckOthersTask")(true);
                          }}
                          message={translate.Edit}
                          value={roleEdit.EditTask}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeleteTask")}
                          message={translate.Delete}
                          value={roleEdit.DeleteTask}
                        ></CheckBoxEditor>
                        <TooltipComponent
                          title={`Al marcar esta opción, el usuario podrá cambiar los estados de las facturas. Por ejemplo
podrá cambiar una factura de un estado “Normal” a “Promesa de pago”.`}
                        >
                          <CheckBoxEditor
                            onChange={(x) => {
                              updateRole("CheckTask")(x);
                              updateRole("CheckOthersTask")(true);
                            }}
                            message={translate.MarkAsCompleted}
                            value={roleEdit.EditTask || roleEdit.CheckTask}
                            disabled={readonly || roleEdit.EditTask}
                            addClass="me-5 my-0 col-auto"
                          ></CheckBoxEditor>
                        </TooltipComponent>
                        <CheckBoxEditor
                          onChange={(checked) =>
                            updateRole("CheckOthersTask")(!checked)
                          }
                          message={translate.OnlyMarkOwnTasks}
                          value={
                            roleEdit.EditTask ||
                            (roleEdit.CheckTask && !roleEdit.CheckOthersTask)
                          }
                          disabled={
                            readonly || roleEdit.EditTask || !roleEdit.CheckTask
                          }
                          addClass="col-auto"
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Tags}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("NewTag")}
                          message={translate.Create}
                          value={roleEdit.NewTag}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditTag")}
                          message={translate.Edit}
                          value={roleEdit.EditTag}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("DeleteTag")}
                          message={translate.Delete}
                          value={roleEdit.DeleteTag}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Reports}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("ViewReport")}
                          message={translate.View}
                          value={roleEdit.ViewReport}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("Export")}
                          message={translate.ExportData}
                          value={roleEdit.Export}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Segments}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditSegment")}
                          message={translate.Configure}
                          value={roleEdit.EditSegment}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Automatic}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("ViewAction")}
                          message={translate.View}
                          value={roleEdit.ViewAction}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditAction")}
                          message={translate.Configure}
                          value={roleEdit.EditAction}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Company}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetCompany")}
                          message={translate.Configure}
                          value={roleEdit.SetCompany}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Roles}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("ViewRole")}
                          message={translate.View}
                          value={roleEdit.ViewRole}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditRole")}
                          message={translate.Configure}
                          value={roleEdit.EditRole}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Users}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("ViewUser")}
                          message={translate.View}
                          value={roleEdit.ViewUser}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditUser")}
                          message={translate.Configure}
                          value={roleEdit.EditUser}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.ActivityType}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditActivityType")}
                          message={translate.Configure}
                          value={roleEdit.EditActivityType}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Importaciones}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("ViewImportLog")}
                          message={translate.ViewLogs}
                          value={roleEdit.ViewImportLog}
                        ></CheckBoxEditor>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetImport")}
                          message={translate.Configure}
                          value={roleEdit.SetImport}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.Dashboards}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("EditDashboard")}
                          message={translate.Configure}
                          value={roleEdit.EditDashboard}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.OtherSettings}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetCompanyOtherSettings")}
                          message={translate.Configure}
                          value={roleEdit.SetCompanyOtherSettings}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.AIAssistant}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("SetAIAssistant")}
                          message={translate.Configure}
                          value={roleEdit.SetAIAssistant}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="d-flex input-column mb-3">
                      <div className="d-flex">
                        <label className="form-label me-4 w-75px">
                          {translate.MCP}
                        </label>
                        <CheckBoxEditor
                          disabled={readonly}
                          onChange={updateRole("UseMCP")}
                          message={translate.Use}
                          value={roleEdit.UseMCP}
                        ></CheckBoxEditor>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {showCashapp && currentTab === "cashapp" && (
              <>
                <div className="row mb-2" style={{ alignItems: "end" }}>
                  <div className="col-auto">
                    <h2 className="pe-4 pb-1">{translate.Permissions}</h2>
                  </div>
                  <div className="col">
                    <CheckBoxEditor
                      disabled={readonly}
                      onChange={chkAllCashappPermissions}
                      message={translate.CheckAll}
                    ></CheckBoxEditor>
                  </div>
                </div>
                {cashappPermissionGroups.map((group) => (
                  <div className="row" key={group.titleKey}>
                    <div className="col">
                      <div className="d-flex input-column mb-3">
                        <div className="d-flex flex-wrap">
                          <label className="form-label me-4 w-75px">
                            {translate[group.titleKey]}
                          </label>
                          {group.items.map((item) => (
                            <CheckBoxEditor
                              key={item.key}
                              disabled={readonly}
                              onChange={updateRole(item.key)}
                              message={translate[item.labelKey]}
                              value={
                                roleEdit[
                                  item.key as keyof RoleEditModel
                                ] as boolean
                              }
                            ></CheckBoxEditor>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        )}
      </div>
      <FloatingPanelFooter>
        {readonly ? (
          <button className="btn btn-primary me-3" onClick={cancelReturn}>
            {translate.Cancel}
          </button>
        ) : (
          <>
            <button className="btn btn-primary me-3" onClick={submit}>
              {translate.Save}
              {saving && (
                <i className="fas fa-spinner-third fa-spin third ms-2"></i>
              )}
            </button>
          </>
        )}
      </FloatingPanelFooter>
    </>
  );
};
